export enum AppRoutesEnum {
    dashboard = 'dashboard',
    calendar = 'calendar',
    profile = 'profile',
    settings = 'settings',
    newPresence = 'new-presence',
    presenceManagement = 'presence-management',
    reports = 'reports'
}
